/**
 * 환경 설정 및 Base URL 관리 유틸리티 (쿠키 방식)
 *
 * 백엔드 서버가 이중화(일반용/대학용)됨에 따라,
 * 백엔드에서 302 리다이렉트 시 설정한 쿠키(api_target)를 확인하여 접속 서버를 구분합니다.
 *
 * 로직:
 * 1. 쿠키(api_target) 확인
 * 2. 값이 'univ'이면 대학생용 서버 URL 반환
 * 3. 값이 없거나 다르면 기본 서버 URL 반환
 */

/**
 * 특정 이름의 쿠키 값을 가져오는 헬퍼 함수
 */
const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
  return null;
};

// 대학생용 서버 URL 환경변수
const UNIV_API_URL = import.meta.env.VITE_API_BASE_URL_UNIV;
const DEFAULT_API_URL = import.meta.env.VITE_API_BASE_URL;

export const getApiBaseUrl = (): string => {
  // 개발 환경에서는 Vite Proxy 사용을 위해 빈 문자열 반환
  if (import.meta.env.DEV) {
    return "";
  }

  // 쿠키에서 대상 서버 확인 (api_target 키 사용)
  const target = getCookie("api_target");

  if (target === "univ") {
    return UNIV_API_URL || DEFAULT_API_URL;
  }

  // 기본값 반환
  return DEFAULT_API_URL;
};

// 앱 전역에서 사용할 Base URL 상수
export const API_BASE_URL = getApiBaseUrl();
